import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebaseConfig";
import { ebooks } from "./EbookStore"; // export ebooks from EbookStore
import { FaArrowLeft } from "react-icons/fa";
import { Helmet } from "react-helmet"; // 

const EbookDetails = ({ cart, setCart }) => {
    const { slug } = useParams();
    const navigate = useNavigate();

    // ✅ All hooks first
    const [user, setUser] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFull, setIsFull] = useState(false); // For fullscreen

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    // ✅ Compute ebook after hooks
    const id = parseInt(slug.split("-").pop());
    const ebook = ebooks.find((book) => book.id === parseInt(id));

    if (!ebook) return <h2 style={{ textAlign: "center", marginTop: "50px" }}>❌ Ebook not found!</h2>;

    const addToCart = () => {
        if (!user) {
            alert("Please login to add items to cart!");
            return;
        }
        setCart([...cart, ebook]);
        alert(`${ebook.name} added to cart!`);
        navigate("/ecart");
    };

    const images = Array.isArray(ebook.image) ? ebook.image : [ebook.image]; // ensure array
    const handlePrev = () => setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    const handleNext = () => setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));

    return (
        <>
            <Helmet>
                <title>{ebook.name} | My Ebook Store</title>
                <meta name="description" content={ebook.description} />
                <meta property="og:title" content={ebook.name} />
                <meta property="og:description" content={ebook.description} />
                <meta property="og:image" content={images[0]} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
            </Helmet>
            <div style={{ padding: "30px", maxWidth: "900px", margin: "auto", fontFamily: "Arial, sans-serif" }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{ background: "transparent", border: "none", color: "#007bff", cursor: "pointer", marginBottom: "20px", fontSize: "18px" }}
                >
                    <FaArrowLeft /> Back
                </button>

                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 300px", minWidth: "280px" }}>
                        <div style={{ position: "relative", borderRadius: "10px", overflow: "hidden", border: "1px solid #ddd" }}>
                            <img
                                src={images[currentIndex]}
                                alt={ebook.name}
                                style={{ width: "100%", height: "400px", objectFit: "cover", cursor: "zoom-in" }}
                                onClick={() => setIsFull(true)}
                            />
                            {images.length > 1 && (
                                <>
                                    <button onClick={handlePrev} style={navBtnStyle("left")}>‹</button>
                                    <button onClick={handleNext} style={navBtnStyle("right")}>›</button>
                                </>
                            )}
                            {/* Stretch icon */}
                            <span
                                onClick={() => setIsFull(true)}
                                style={{
                                    position: "absolute",
                                    bottom: "20px",
                                    right: "20px",
                                    background: "rgba(0,0,0,0.5)",
                                    color: "#fff",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    userSelect: "none"
                                }}
                            >
                                🔍
                            </span>
                        </div>

                        {images.length > 1 && (
                            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                {images.map((img, idx) => (
                                    <img
                                        key={idx}
                                        src={img}
                                        alt={`thumb-${idx}`}
                                        onClick={() => setCurrentIndex(idx)}
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            objectFit: "cover",
                                            border: idx === currentIndex ? "2px solid #007bff" : "1px solid #ccc",
                                            borderRadius: "6px",
                                            cursor: "pointer"
                                        }}
                                    />
                                ))}
                            </div>
                        )}
                    </div>

                    <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
                        <h2 style={{ marginBottom: "15px", fontWeight: "bold" }}>{ebook.name}</h2>
                        <p style={{ lineHeight: "1.6", marginBottom: "20px", color: "#555" }}>{ebook.description}</p>
                        <h3 style={{ marginBottom: "20px" }}>Price: ₹{ebook.price}</h3>
                        <button
                            onClick={addToCart}
                            style={{
                                background: "#007bff",
                                color: "#fff",
                                padding: "12px 25px",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "16px",
                                fontWeight: "bold"
                            }}
                        >
                            🛒 Add to Cart
                        </button>

                        {ebook.previewLink && (
                            <div style={{ marginTop: "20px" }}>
                                <a
                                    href={ebook.previewLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#28a745", textDecoration: "underline" }}
                                >
                                    📥 Click For Demo PDF
                                </a>
                            </div>
                        )}
                    </div>
                </div>

                {/* Fullscreen overlay */}
                {isFull && (
                    <div
                        onClick={() => setIsFull(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.8)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                            cursor: "zoom-out",
                        }}
                    >
                        <img
                            src={images[currentIndex]}
                            alt={ebook.name}
                            style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "8px" }}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

const navBtnStyle = (position) => ({
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    [position]: "10px",
    background: "rgba(0,0,0,0.4)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    fontSize: "20px",
    cursor: "pointer"
});

export default EbookDetails;
